// @flow @format
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'lib/classnames';
import './Logo.css';
import darkLogo from './dark-logo.png';
import lightLogo from './light-logo.png';

type Theme = 'light' | 'dark';

type Props = {theme: Theme, className: string};

class Logo extends PureComponent<Props, void> {
	static defaultProps = {
		theme: 'light',
		className: '',
	};

	static propTypes = {
		theme: PropTypes.oneOf(['light', 'dark']),
		className: PropTypes.string,
	};

	render() {
		const {theme, className} = this.props;
		const classes = classNames('Logo', className);

		return (
			<img
				className={classes}
				src={theme === 'light' ? lightLogo : darkLogo}
				alt="Cloner"
				title="Cloner"
			/>
		);
	}
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js